<template>
  <div class="order-box">
    <div class="order-top">
      <div
        @click.prevent="onCheck(item)"
        class="top-type"
        v-for="(item,index) in typeList "
        :key="index"
      >
        <div :class="checkType==item.type ? 'type-class check-class':'type-class'">{{item.name}}</div>
      </div>
    </div>
    <div v-if="checkType=='1'" class="pull-refreh-height">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="order-content" v-for="(item,index) in loanList" :key="index">
            <div class="order-clo">
              <div>订单编号：</div>
              <div>{{item.orderId}}</div>
            </div>
            <div class="order-clo">
              <div>状态：</div>
              <div>{{item.status}}</div>
            </div>
            <div class="order-clo">
              <div>订单日期：</div>
              <div>{{item.createTime}}</div>
            </div>
            <div class="order-clo">
              <div>结算金额：</div>
              <div>{{item.settlementAmount}}</div>
            </div>
            <div class="order-clo">
              <div>结算时间：</div>
              <div>{{item.settleTime}}</div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div v-if="checkType=='2'" class="pull-refreh-height">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="order-safe order-content" v-for="(item,index) in safeList" :key="index">
            <div class="order-clo">
              <div>订单编号：</div>
              <div>{{item.orderCode}}</div>
            </div>
            <div class="order-clo">
              <div>产品名称：</div>
              <div>{{item.productName}}</div>
            </div>
            <div class="order-clo">
              <div>投保人：</div>
              <div>{{item.name}}</div>
            </div>
            <div class="order-clo">
              <div>手机号码：</div>
              <div>{{item.phoneNo}}</div>
            </div>
            <div class="order-clo-but">
              <van-button plain color="#FC6C21" @click="onDetails(item)" round>查看详情</van-button>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>

    <div class="order-but">
      <van-button round @click="myCreated(checkType)" color="linear-gradient(to right, #FC6C21, #F85D33)">创建订单</van-button>
    </div>
  </div>
</template>
<script>
import URL from "@/api/api";
import { Toast} from "vant";
export default {
  data() {
    return {
      typeList: [
        { name: '贷款', type: 1 },
        { name: '保险', type: 2 }
      ],
      checkType: 1,
      loan: true,//true为贷款
      openid: localStorage.getItem("openid"),
      loanList: [],
      safeList: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1, //页数
      size: 5,//总条数
      total: 0
    }
  },
  mounted() {
  },
  methods: {
    onCheck(item) {
      this.checkType = item.type
      this.page = 1
      this.finished = false;
      this.loading = true;
      if (!item.type) {
        this.loan = true
        this.getLoanList()
      } else {
        this.loan = false
        this.getSafeList()
      }
    },
    myCreated(type) {
      this.$router.push({path:'/createOrder/details',query:{type}})
    },
    onDetails(item) {
      this.$router.push({
        path:'/insuranceDetails',
        query:{id:item.orderCode,type:item.orderSource}
      })
    },
    checkOrder(orderNo) {
      this.$router.push({ path: '/createOrderT/details', query: { orderNo: orderNo } })
    },
    getLoanList() {
      let that = this
      let data = {
        page: this.page,
        size: this.size,
        phone:sessionStorage.getItem("phone")
      }
      that.$fetchGet(URL.loanList.url, data).then(res => {
        if (res.data.code == 20000) {
          let list = res.data.data.records; //请求返回当页的列表
          that.refreshing = false;
          that.loading = false;
          Toast.clear()
          that.total = res.data.data.total;
          if (list == null || list.length === 0) {
            // 加载结束
            that.finished = true;
            return;
          }
          // 将新数据与老数据进行合并
          if (that.page > 1) {
            that.loanList = [...that.loanList, ...list]
          } else {
            that.loanList = list
          }
          //如果列表数据条数>=总条数，不再触发滚动加载
          if (that.loanList.length >= that.total) {
            that.finished = true;
          }
          // 如果总页数大于当前页码，页码+1
          if (that.size * that.page < that.total) {
            that.page++;
          }
        }
        // this.loanList=res.data.data.records
      })
    },
    getSafeList() {
      let that = this
      let data = {
        page: this.page,
        size: this.size,
        agentPhoneNo: sessionStorage.getItem("phone")
      }
      that.$fetchGet(URL.safeList.url, data).then(res => {
        if (res.data.code == 20000) {
          let list = res.data.data.records; //请求返回当页的列表
          that.refreshing = false;
          that.loading = false;
          Toast.clear()
          that.total = res.data.data.total;
          if (list == null || list.length === 0) {
            // 加载结束
            that.finished = true;
            return;
          }
          // 将新数据与老数据进行合并
          if (that.page > 1) {
            that.safeList = [...that.safeList, ...list]
          } else {
            that.safeList = list
          }
          //如果列表数据条数>=总条数，不再触发滚动加载
          if (that.safeList.length >= that.total) {
            that.finished = true;
          }
          // 如果总页数大于当前页码，页码+1
          if (that.size * that.page < that.total) {
            that.page++;
          }
        }
        // this.loanList=res.data.data.records
      })
    },
    onRefresh() {
      this.finished = false;
      this.pageNum = 1
      this.loading = true;
      //贷款
      if (this.loan) {
        this.getLoanList()
      }else{
        this.getSafeList()
      }
    },
    //触底回调函数(页面刷新由于finished为false 触发了触底回调)
    onLoad() {
       //贷款
      if (this.loan) {
        this.getLoanList()
      }else{
        this.getSafeList()
      }
    }
  }
}
</script>
<style lang="less" scoped>
.order-box {
  width: 375px;
  height: 100vh;
  background: #fffbf8;
  // overflow: scroll;
  font-family: Source Han Sans CN;
  font-weight: Regular;
  color: #333333;
}
.order-top {
  width: 375px;
  height: 30px;
  margin-top: 5px;
  display: flex;
  align-items: center;
  background: #fff;
  .top-type {
    width: 188px;
    height: 22px;
    text-align: center;
    font-size: 14px;
    color: #333333;
    &:last-child {
      border-left: 1px solid #ededed;
    }
    .type-class {
      width: 42px;
      height: 22px;
      margin: auto;
    }
    .check-class {
      color: #f9622c;
      border-bottom: 1px solid #f9622c;
    }
  }
}
.pull-refreh-height{
  height: calc(100vh - 200px);
  overflow: scroll;
}
.order-content {
  width: 355px;
  height: 185px;
  margin: 10px auto;
  background: #fff;
  border-radius: 10px;
  font-size: 12px;
  .order-clo {
    height: 12px;
    display: flex;
    justify-content: space-between;
    padding: 20px 20px 0 20px;
    div:last-child {
      color: #999999;
    }
  }
}
.order-safe {
  height: 195px;
  .order-clo-but {
    padding: 20px 20px 0 20px;
    text-align: right;
    .van-button {
      width: 79px;
      height: 22px;
      font-size: 12px;
      padding: 0;
    }
  }
}
.order-but {
  width: 93px;
  margin: 80px auto 20px auto;
  .van-button {
    width: 93px;
  }
}
</style>
